"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var Link_1 = __importDefault(require("../Link"));
var Text_1 = __importDefault(require("../Text"));
var Button_1 = __importDefault(require("../Button"));
var Icon_1 = __importDefault(require("../Icon"));
function RegionSelector(props) {
    var regions = props.regions, footerRegion = props.footerRegion;
    var _a = (0, react_1.useState)(false), open = _a[0], setOpen = _a[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var handler = function (event) {
            if (!ref.current)
                return;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
            if (!ref.current.contains(event.target)) {
                if (open) {
                    setOpen(false);
                }
            }
        };
        document.addEventListener("click", handler);
        return function () {
            document.removeEventListener("click", handler);
        };
    }, [open]);
    var handleLanguageClick = function () {
        setOpen(true);
    };
    var current = regions === null || regions === void 0 ? void 0 : regions.find(function (x) { return x.code === footerRegion; });
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Icon_1.default, { name: 'ff-icon-language', fontSize: '18px', color: 'white' }),
        current &&
            react_1.default.createElement(Button_1.default, { onClick: handleLanguageClick },
                react_1.default.createElement(CurrentLanguage, null, current.country)),
        react_1.default.createElement(Arrow, { open: open, name: 'ff-icon-triangle-up' }),
        open &&
            react_1.default.createElement(Popup, { ref: ref }, regions === null || regions === void 0 ? void 0 : regions.map(function (region) { return (react_1.default.createElement(RegionLink, { key: region.code, href: region.url },
                react_1.default.createElement(CountryText, null, region.country))); }))));
}
var Container = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
});
var CurrentLanguage = (0, styled_1.default)(Text_1.default)({
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '14px',
    lineHeight: '26px',
    marginLeft: '11.28px',
    marginRight: '16.5px',
    cursor: 'pointer',
    textTransform: 'none',
    whiteSpace: 'nowrap',
});
var Popup = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            borderRadius: '4px',
            padding: '16px 16px',
            position: 'absolute',
            bottom: 'calc(100% + 18px)',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
        },
        _b[theme.mediaQueries.md] = {
            transform: 'translateX(-15%)'
        },
        _b);
});
var RegionLink = (0, styled_1.default)(Link_1.default)({
    borderRadius: '2px',
    padding: '4px 12px',
    ':hover': {
        backgroundColor: 'rgba(116, 116, 128, 0.08)'
    }
});
var CountryText = (0, styled_1.default)(Text_1.default)({
    whiteSpace: 'nowrap',
    minWidth: '126px',
    fontSize: '14px',
    lineHeight: '26px',
    color: 'rgba(23, 26, 32, 1)',
});
var Arrow = (0, styled_1.default)(Icon_1.default)(function (_a) {
    var open = _a.open;
    return ({
        color: 'white',
        fontSize: '5px',
        transform: open ? 'rotate(0deg)' : 'rotate(90deg)',
        transitionProperty: 'transform',
        transitionDuration: '300ms'
    });
});
exports.default = RegionSelector;
